import { createSlice } from '@reduxjs/toolkit';

export const mainTabSlice = createSlice({
  name: 'mainTab',
  initialState: {
    currentMainTab: null,
    resetStates: false,
  },
  reducers: {
    setCurrentMainTab: (state, action) => {
      state.currentMainTab = action.payload;
    },
    setResetStates:(state, action) => {
      state.resetStates = action.payload;
    }
  }
});

export const {
  setCurrentMainTab,
  setResetStates,
} = mainTabSlice.actions;

export default mainTabSlice.reducer;
